// App.js
import React from "react";
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { BrowserRouter as Router } from "react-router-dom";
import AppRoutes from "./AppRoutes";
import CookieNotice from './components/privacy/CookieNotice';
import Analytics from './components/privacy/Analytics';

export default function App() {
  return (
    <DndProvider backend={HTML5Backend}>
      <Router>
        <Analytics />
        <AppRoutes />
        <CookieNotice />
      </Router>
    </DndProvider>
  );
}
